import {
  Add as AddIcon
} from "@mui/icons-material";
import {
  Box,
  Card,
  CardMedia,
  Grid,
  Icon,
  IconButton,
  InputLabel,
  Stack,
  Typography,
  useMediaQuery,
  useTheme
} from "@mui/material";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import MDSelect from "components/MDSelect";
import { MDTextFieldCalendar } from "components/MDTextFiedCalendar";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";
import moment from "moment";
import "moment/locale/pt-br";
import { useState, useEffect, useMemo, useRef } from "react";
import logo from "../../assets/images/logos/logo.png";
import logoDark from "../../assets/images/logos/logo_dark.png";
import { useUser } from "context/UserContext";
import { post, get } from "utils/WebService";
import ModalCriarAgenda from "./modal/CreateAgendaModal";
import ModalDetails from "./modal/DetailsModal";
import CasesCreateEdit from "../legalConsult/cases/CasesCreateEdit";
import CircularProgress from "@mui/material/CircularProgress";
import Cases from "views/legalConsult/cases/Cases";
import AgendaDayColumn from "components/AgendaDayColumn";
import AgendaEventCard from "components/AgendaEventCard";
import { useNavigate } from "react-router-dom";
import BaseDeDadosCreateEdit from "../umc/baseDeDados/BaseDeDadosCreateEdit";
import ModalResumoFila from "./modal/ModalResumoFila";
import { TIPO_PERFIL, temTipoPerfil } from "utils/Perfis";
import { ESCURO } from "assets/coresTema";

export default function Home() {
  const [currentDate, setCurrentDate] = useState(moment());
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [usuarios, setUsuarios] = useState([])
  const [openCreate, setOpenCreate] = useState(false);
  const [openProcesso, setOpenProcesso] = useState(null);
  const [loadingEvents, setLoadingEvents] = useState(false);
  const navigate = useNavigate();
  const [clienteList, setClienteList] = useState([])
  const [openHistory, setOpenHistory] = useState(false)
  const [openFicha, setOpenFicha] = useState(false)
  const [processoId, setProcessoId] = useState(null);
  const [fichaId, setFichaId] = useState(null);
  const [idDeadLine, setIdDeadLine] = useState(null);
  const [table, setTable] = useState(null);
  const [loadingUsuarios, setLoadingUsuarios] = useState(false);
  const [loadingPeople, setLoadingPeople] = useState(false);
  const [carteiraList, setCarteiraList] = useState([]);
  const [statusFichaList, setStatusFichaList] = useState([]);
  const [loadingCarteira, setLoadingCarteira] = useState(false);

  const [resumoFilaData, setResumoFilaData] = useState(null);
  const [loadingResumoFila, setLoadingResumoFila] = useState(false);
  const [openResumoModal, setOpenResumoModal] = useState(false);
  const [modalResumoTitle, setModalResumoTitle] = useState("");
  const [modalResumoBlockData, setModalResumoBlockData] = useState(null);
  const [modalResumoColor, setModalResumoColor] = useState("info");


  const {
    statusPrazoEnum,
    tipoEventoEnum,
    tipoFiltroAgendaEnum,
    tipoAgendaEnum,
    sistemasEnum,
    tipoPartesEnum,
    userId,
    userGestor,
    userPerfils,
    userFunctionalities
  } = useUser();

  const canCreateEvento = useMemo(() => {
    if (userFunctionalities && Array.isArray(userFunctionalities) && userFunctionalities.length > 0) {
      return userFunctionalities.includes("c077") || userFunctionalities.includes("c077_C");
    }
    return temTipoPerfil(userPerfils, TIPO_PERFIL.GESTOR, TIPO_PERFIL.COORDENADOR, TIPO_PERFIL.ADMINISTRADOR);
  }, [userPerfils, userFunctionalities]);
  const tipoFiltroAgendaSelect = tipoFiltroAgendaEnum.filter(
    (item) => item.code !== "fromUntil"
  );

  const effectiveCurrentUserId = userId || sessionStorage.getItem("userId");

  useEffect(() => {
    if (!effectiveCurrentUserId) return;
    setLoadingUsuarios(true);
    get(`/equipe/usuarios/${effectiveCurrentUserId}`).then(({ list }) => {
      const userList = list || [];
      setUsuarios(userList);
      setFilters(prev => {
        if (!prev.atribuidoA && effectiveCurrentUserId) {
          return { ...prev, atribuidoA: effectiveCurrentUserId };
        }
        return prev;
      });
    }).catch(() => {
      setUsuarios([]);
    }).finally(() => {
      setLoadingUsuarios(false);
    });
  }, [effectiveCurrentUserId]);

  useEffect(() => {
    setLoadingPeople(true)
    get(`/pessoa/list-all`).then(({ list }) => {
      setClienteList(list)
    }).catch(() => {
      setClienteList([])
    }).finally(() => {
      setLoadingPeople(false);
    });

    setLoadingCarteira(true);
    get(`/carteira/list-all`).then((res) => {
      const list = res.list || [];
      setCarteiraList(list);
      // Auto-selecionar se o usuario pertencer a exatamente 1 carteira
      if (list.length === 1 && !filters.carteiraId) {
        setFilters(prev => ({ ...prev, carteiraId: list[0].id }));
      }
    }).catch(() => {
      setCarteiraList([]);
    }).finally(() => {
      setLoadingCarteira(false);
    });

    get(`/status-ficha/list-all`).then((res) => {
      setStatusFichaList(res.list || []);
    });
  }, []);

  useEffect(() => {
    updateDateRange(filters.view);
  }, [currentDate]);

  const isCoordenador = temTipoPerfil(userPerfils, TIPO_PERFIL.COORDENADOR);
  const isGestorOuAdmin = userGestor || temTipoPerfil(userPerfils, TIPO_PERFIL.GESTOR, TIPO_PERFIL.ADMINISTRADOR);

  const isOperacaoOuBackoffice = useMemo(() =>
    temTipoPerfil(userPerfils, TIPO_PERFIL.MEMBROS, TIPO_PERFIL.OPERACAO, TIPO_PERFIL.BACKOFFICE),
  [userPerfils]);

  const showResumoBlocks = isOperacaoOuBackoffice && !isGestorOuAdmin && !isCoordenador;

  const defaultView = localStorage.getItem("home_agenda_view") || "week";
  const initialDate = moment();
  const initialDataInicio = defaultView === "month"
    ? initialDate.clone().startOf("month").format("YYYY-MM-DD")
    : defaultView === "day"
      ? initialDate.format("YYYY-MM-DD")
      : initialDate.clone().startOf("week").format("YYYY-MM-DD");
  const initialDataFim = defaultView === "month"
    ? initialDate.clone().endOf("month").format("YYYY-MM-DD")
    : defaultView === "day"
      ? initialDate.format("YYYY-MM-DD")
      : initialDate.clone().endOf("week").format("YYYY-MM-DD");

  const storedUserId = userId || sessionStorage.getItem("userId") || null;

  const INITIAL_FILTERS = {
    tipoPrazo: null,
    atribuidoA: storedUserId,
    status: null,
    view: defaultView,
    dataInicio: initialDataInicio,
    dataFim: initialDataFim,
    processo: "",
    clienteId: null,
    carteiraId: null,
    statusFichaId: null,
    dataInicioPublicacao: null,
    dataFimPublicacao: null,
  };

  const [filters, setFilters] = useState(INITIAL_FILTERS);
  const fetchAgendaSeq = useRef(0);

  useEffect(() => {
    if (userId) {
      setFilters(prev => {
        if (prev.atribuidoA === null || prev.atribuidoA === undefined) {
          return { ...prev, atribuidoA: userId };
        }
        return prev;
      });
    }
  }, [userId]);

  const [search, setSearch] = useState({
    processo: "",
  });

  const handleClearFilters = () => {
    setSearch({ processo: "" });

    setFilters(prev => ({
      ...INITIAL_FILTERS,
      atribuidoA: userId || sessionStorage.getItem("userId") || null,
      view: prev.view,
    }));

    updateDateRange(filters.view);
  };

  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down("sm"));
  const isMedium = useMediaQuery(theme.breakpoints.down("md"));
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  const date = moment(currentDate);

  const minDate =
    filters.view === "month"
      ? date.startOf("month").format("YYYY-MM-DD")
      : filters.view === "week"
        ? date.startOf("week").format("YYYY-MM-DD")
        : filters.view === "day"
          ? null
          : null;

  const maxDate =
    filters.view === "month"
      ? date.endOf("month").format("YYYY-MM-DD")
      : filters.view === "week"
        ? date.endOf("week").format("YYYY-MM-DD")
        : filters.view === "day"
          ? null
          : null;

  const fetchResumoFila = async () => {
    try {
      setLoadingResumoFila(true);
      const targetUserId = filters.atribuidoA || userId || "";
      const targetData = currentDate ? moment(currentDate).format("YYYY-MM-DD") : "";
      const res = await get(`/fila-trabalho/resumo-home?userId=${targetUserId}&data=${targetData}`);
      if (res) {
        setResumoFilaData(res);
      }
    } catch (err) {
      console.log("Erro ao buscar resumo da fila:", err);
    } finally {
      setLoadingResumoFila(false);
    }
  };

  useEffect(() => {
    fetchAgenda();
    fetchResumoFila();
  }, [filters]);

  useEffect(() => {
    fetchResumoFila();

    // Atualização automática a cada 30 segundos
    const interval = setInterval(() => {
      fetchResumoFila();
    }, 30000);

    const handleUpdate = () => fetchResumoFila();
    window.addEventListener("focus", handleUpdate);
    window.addEventListener("fila-trabalho-updated", handleUpdate);

    return () => {
      clearInterval(interval);
      window.removeEventListener("focus", handleUpdate);
      window.removeEventListener("fila-trabalho-updated", handleUpdate);
    };
  }, [filters.atribuidoA, userId, currentDate]);

  const handleOpenResumoDetail = (title, blockData, color) => {
    setModalResumoTitle(title);
    setModalResumoBlockData(blockData);
    setModalResumoColor(color);
    setOpenResumoModal(true);
  };

  const renderStatusChips = (porStatusMap, color) => {
    if (!porStatusMap || Object.keys(porStatusMap).length === 0) {
      return (
        <MDBox display="flex" alignItems="center" minHeight="28px" mt={0.5}>
          <MDTypography variant="caption" color="text" sx={{ opacity: 0.6, fontSize: "0.75rem" }}>
            Sem casos na fila
          </MDTypography>
        </MDBox>
      );
    }

    return (
      <MDBox
        display="flex"
        flexWrap="wrap"
        alignContent="flex-start"
        gap={0.6}
        mt={0.5}
        sx={{
          minHeight: "28px",
          maxHeight: "55px",
          overflowY: "auto",
          pr: 0.5,
          "&::-webkit-scrollbar": { width: "4px" },
          "&::-webkit-scrollbar-thumb": { backgroundColor: darkMode ? ESCURO.hover : "#ccc", borderRadius: "4px" },
        }}
      >
        {Object.entries(porStatusMap).map(([statusName, count]) => (
          <MDBox
            key={statusName}
            px={0.8}
            py={0.15}
            borderRadius="5px"
            bgcolor={darkMode ? ESCURO.painel : "#edf2f7"}
            display="flex"
            alignItems="center"
            gap={0.5}
          >
            <MDTypography variant="caption" fontWeight="regular" color="text" sx={{ fontSize: "0.72rem" }}>
              {statusName}:
            </MDTypography>
            <MDTypography variant="caption" fontWeight="bold" color={color} sx={{ fontSize: "0.72rem" }}>
              {count}
            </MDTypography>
          </MDBox>
        ))}
      </MDBox>
    );
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      setFilters(prev => ({
        ...prev,
        processo: search.processo,
      }));
    }, 500);

    return () => clearTimeout(handler);
  }, [search.processo]);


  moment.locale("pt-br");

  const [events, setEvents] = useState([]);

  const handlePrev = () => {
    const unit = filters.view === "month" ? "month" : filters.view === "week" ? "week" : "day";
    setCurrentDate(moment(currentDate).subtract(1, unit));
  };

  const handleNext = () => {
    const unit = filters.view === "month" ? "month" : filters.view === "week" ? "week" : "day";
    setCurrentDate(moment(currentDate).add(1, unit));
  };

  const handleOpenModal = (evento) => {
    if (evento?.tipoEventoStr === "ficha_agendada") {
        if (evento?.prazo?.casoProcessual?.id) {
            setFichaId(evento.prazo.casoProcessual.id);
            setOpenFicha(true);
        }
        return;
    }
    setSelectedEvent(evento);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setSelectedEvent(null);
    setOpenModal(false);
  };

  const updateDateRange = (view) => {
    const date = moment(currentDate);

    if (view === "month") {
      setFilters(prev => ({
        ...prev,
        dataInicio: date.startOf("month").format("YYYY-MM-DD"),
        dataFim: date.endOf("month").format("YYYY-MM-DD")
      }));
    }

    if (view === "week") {
      setFilters(prev => ({
        ...prev,
        dataInicio: date.startOf("week").format("YYYY-MM-DD"),
        dataFim: date.endOf("week").format("YYYY-MM-DD")
      }));
    }

    if (view === "day") {
      setFilters(prev => ({
        ...prev,
        dataInicio: date.format("YYYY-MM-DD"),
        dataFim: date.format("YYYY-MM-DD")
      }));
    }
  };

  const renderCalendar = () => {
    const startOfMonth = moment(currentDate).startOf("month");
    const endOfMonth = moment(currentDate).endOf("month");

    const startDate = startOfMonth.clone().startOf("week");
    const endDate = endOfMonth.clone().endOf("week");

    const calendarDays = [];
    let day = startDate.clone();
    while (day.isSameOrBefore(endDate, "day")) {
      calendarDays.push(day.clone());
      day.add(1, "day");
    }

    const weekDays = moment.weekdaysShort(true);

    if (loadingEvents) {
      return (
        <Box sx={{
          height: "calc(100vh - 310px)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}>
          <CircularProgress size={48} />
        </Box>
      );
    }

    if (filters.view === "month") {
      return (
        <Box>
          <Box sx={{ display: { xs: "none", sm: "block" } }}>
            <Grid container spacing={1} sx={{ mb: 1 }}>
              {weekDays.map((dayName, i) => (
                <Grid item xs={12 / 7} key={i}>
                  <Box
                    sx={{
                      textAlign: "center",
                      fontWeight: "bold",
                      color: darkMode ? "#ffffffff" : "#444",
                      textTransform: "uppercase",
                      fontSize: "0.75rem",
                      letterSpacing: 0.5,
                      pb: 0.5,
                    }}
                  >
                    {dayName}
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Box>

          <Grid container spacing={1}>
            {calendarDays.map((date, i) => {
              const isCurrentMonth = date.isSame(currentDate, "month");
              return (
                <Grid item xs={isSmall ? 6 : isMedium ? 12 / 5 : 12 / 7} key={i}>
                  {isCurrentMonth ? (
                    <AgendaDayColumn
                      date={date}
                      events={events.filter(e => moment(e.data).isSame(date, "day"))}
                      view={filters.view}
                      darkMode={darkMode}
                      tipoEventoEnum={tipoEventoEnum}
                      statusPrazoEnum={statusPrazoEnum}
                      sistemasEnum={sistemasEnum}
                      tipoPartesEnum={tipoPartesEnum}
                      onEventClick={handleOpenModal}
                    />
                  ) : (
                    <Box
                      sx={{
                        height: filters.view === "month" ? 220 : "auto",
                        backgroundColor: darkMode ? ESCURO.painelEscuro : "#fafafa",
                        borderRadius: 2,
                      }}
                    />
                  )}
                </Grid>
              );
            })}
          </Grid>
        </Box>
      );
    }

    if (filters.view === "week") {
      const startWeek = moment(currentDate).startOf("week");
      const daysOfWeek = Array.from({ length: 7 }, (_, i) =>
        startWeek.clone().add(i, "day")
      );
      const weekDays = moment.weekdaysShort(true);
      return (
        <Box>
          <Box sx={{ display: { xs: "none", md: "block" } }}>
            <Grid container spacing={1} sx={{ mb: 1 }}>
              {weekDays.map((dayName, i) => (
                <Grid item xs={isSmall ? 12 : isMedium ? 12 / 3 : 12 / 7} key={i}>
                  <Box
                    sx={{
                      textAlign: "center",
                      fontWeight: "bold",
                      color: darkMode ? "#ffffffff" : "#444",
                      textTransform: "uppercase",
                      fontSize: "0.75rem",
                      letterSpacing: 0.5,
                    }}
                  >
                    {dayName}
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Box>

          <Grid
            container
            spacing={1}
            sx={{
              height: "calc(100vh - 302px)",
              overflowY: "hidden",
            }}
          >
            {daysOfWeek.map((date, i) => (
              <Grid item xs={isSmall ? 12 : isMedium ? 12 / 3 : 12 / 7} key={i}>
                <AgendaDayColumn
                  date={date}
                  events={events.filter(e => moment(e.data).isSame(date, "day"))}
                  view={filters.view}
                  darkMode={darkMode}
                  tipoEventoEnum={tipoEventoEnum}
                  statusPrazoEnum={statusPrazoEnum}
                  sistemasEnum={sistemasEnum}
                  tipoPartesEnum={tipoPartesEnum}
                  onEventClick={handleOpenModal}
                />
              </Grid>
            ))}
          </Grid>
        </Box>
      );
    }

    if (filters.view === "day") {
      return (
        <Box sx={{ height: "calc(100vh - 310px)", overflowY: "hidden" }}>
          <Box sx={{ height: "100%" }}>
            <AgendaDayColumn
              date={currentDate}
              events={events.filter(e =>
                moment(e.data).isSame(currentDate, "day")
              )}
              view={filters.view}
              darkMode={darkMode}
              tipoEventoEnum={tipoEventoEnum}
              statusPrazoEnum={statusPrazoEnum}
              sistemasEnum={sistemasEnum}
              tipoPartesEnum={tipoPartesEnum}
              onEventClick={handleOpenModal}
            />
          </Box>
        </Box>
      );
    }

    if (filters.view === "fromUntil") {
      const start = moment(filters.dataInicio);
      const end = moment(filters.dataFim);

      if (!start.isValid() || !end.isValid()) return null;

      const rangeEvents = events.filter(e => {
        const d = moment(e.data);
        return d.isSameOrAfter(start, "day") && d.isSameOrBefore(end, "day");
      });

      rangeEvents.sort((a, b) => moment(a.data) - moment(b.data));

      return (
        <Box sx={{ height: "calc(100vh - 310px)", overflowY: "auto", p: 1 }}>
          {rangeEvents.length === 0 && (
            <Typography sx={{ textAlign: "center", mt: 4, opacity: 0.6 }}>
              Nenhum evento no intervalo selecionado.
            </Typography>
          )}

          {rangeEvents.map((ev, i) => (
            <Box key={i} sx={{ mb: 1 }}>
              <AgendaEventCard
                  evento={ev}
                  darkMode={darkMode}
                  tipoEventoEnum={tipoEventoEnum}
                  statusPrazoEnum={statusPrazoEnum}
                  sistemasEnum={sistemasEnum}
                  tipoPartesEnum={tipoPartesEnum}
                  onClick={handleOpenModal}
                  showDate={true}
              />
            </Box>
          ))}
        </Box>
      );
    }

    return null;
  };

  const fetchAgenda = async () => {
    const seq = ++fetchAgendaSeq.current;
    if (!filters.dataInicio || !filters.dataFim) {
      return;
    }

    try {
      setLoadingEvents(true);
      const targetUserId = filters.atribuidoA !== undefined
        ? filters.atribuidoA
        : (userId || sessionStorage.getItem("userId") || null);

      const body = {
        tipoAgenda: filters.tipoAgenda || null,
        tipoPrazo: filters.tipoPrazo || null,
        pessoaAtribuidaId: targetUserId || null,
        statusPrazo: filters.status || null,
        dataInicio: filters.dataInicio || null,
        dataFim: filters.dataFim || null,
        processo: filters.processo || null,
        clienteId: filters.clienteId || null,
        dataInicioPublicacao: filters?.dataInicioPublicacao || null,
        dataFimPublicacao: filters?.dataFimPublicacao || null,
        carteiraId: filters?.carteiraId || null,
        statusFichaId: filters?.statusFichaId || null,
      };

      const response = await post("/agenda/list", body);
      if (seq === fetchAgendaSeq.current) {
        setEvents(response.list || []);
      }
    } catch (err) {
      console.log(" Erro ao buscar agenda:", err);
    } finally {
      if (seq === fetchAgendaSeq.current) {
        setLoadingEvents(false);
      }
    }
  };

  const handleOpenProcess = (processoId) => {
    setOpenProcesso(processoId);
  };

  const handleOpenHistory = (processoId, idDeadLine, table = null) => {
    if (idDeadLine && String(idDeadLine).startsWith("FICHA_")) {
      setFichaId(processoId);
      setOpenFicha(true);
      return;
    }
    
    setTable(table)
    setIdDeadLine(idDeadLine)
    setProcessoId(processoId)
    setOpenHistory(true)
  };

  const handleBackFromCases = () => {
    setOpenHistory(false);
    setProcessoId(null);
    setIdDeadLine(null);
    setTable(null);
  };

  const withAllOption = (list, label = "Todos") => {
    return [{ id: null, code: null, name: label }, ...list];
  };

  const hasCobranca = filters.carteiraId 
    ? carteiraList.find(c => c.id === filters.carteiraId)?.cbCobranca === true
    : carteiraList.some(c => c.cbCobranca === true);

  const hasProcessos = filters.carteiraId 
    ? carteiraList.find(c => c.id === filters.carteiraId)?.cbCobranca !== true
    : carteiraList.length === 0 ? true : carteiraList.some(c => c.cbCobranca !== true);
  
  const isAdmin = 
    userGestor === true || 
    userGestor === 1 || 
    userGestor === "1" || 
    userGestor === "true" || 
    temTipoPerfil(userPerfils, TIPO_PERFIL.GESTOR, TIPO_PERFIL.ADMINISTRADOR);

  const isCoordinator = temTipoPerfil(userPerfils, TIPO_PERFIL.COORDENADOR);

  const showAllFilters = !filters.carteiraId && isAdmin;

  return (
    <>
      {openProcesso && (
        <CasesCreateEdit
          id={openProcesso}
          closeCreateEdit={() => setOpenProcesso(null)}
        />
      )}

      {openHistory && (
        <Cases
          id={processoId}
          initialTab="Deadlines"
          idDeadLine={idDeadLine}
          table={table}
          onBack={handleBackFromCases}
        />
      )}

      {openFicha && (
        <BaseDeDadosCreateEdit
          recordId={fichaId}
          closeCreateEdit={() => { setOpenFicha(false); setFichaId(null); fetchAgenda(); }}
          isJuridico={false}
          isViewOnly={false}
        />
      )}

      <Card sx={{ p: isSmall ? 1 : 3, backgroundColor: darkMode ? ESCURO.cartao : "#fff", display: openProcesso || openHistory || openFicha ? "none" : "" }}>

        <Stack
          direction={isSmall ? "column" : "row"}
          alignItems="center"
          justifyContent="space-between"
          spacing={2}
          sx={{ mb: 2 }}
        >
          <Stack
            direction="row"
            alignItems="center"
            spacing={2}
            sx={{ width: "100%", justifyContent: { xs: "center", md: "space-between" } }}
          >
            <MDBox
              sx={{
                width: 250,
                height: 100,
                paddingRight: 4,
                display: { xs: "none", md: "block" }
              }}
            >
              <Box
                component="img"
                src={darkMode ? logoDark : logo}
                alt="Logo"
                sx={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                  mixBlendMode: darkMode ? "screen" : "multiply", // Efeito de transparência artificial
                  filter: "brightness(1.1)", // Pequeno boost para compensar a mesclagem
                }}
              />
            </MDBox>

            <Stack direction="row" alignItems="center" spacing={1}>
              <IconButton onClick={handlePrev}>
                <MDTypography variant="h4">
                  <Icon>arrow_back</Icon>
                </MDTypography>
              </IconButton>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: "bold",
                  textTransform: "capitalize",
                  color: darkMode ? "#fff" : "#000",
                  minWidth: 200,
                  textAlign: "center",
                }}
              >
                {filters.view === "day"
                  ? moment(currentDate).format("DD [de] MMMM - YYYY")
                  : filters.view === "week"
                    ? `Semana ${moment(currentDate).startOf('week').format('DD/MM/YYYY')} a ${moment(currentDate).endOf('week').format('DD/MM/YYYY')}`
                    : moment(currentDate).format("MMMM - YYYY")}
              </Typography>

              <IconButton onClick={handleNext}>
                <MDTypography variant="h4">
                  <Icon>arrow_forward</Icon>
                </MDTypography>
              </IconButton>
            </Stack>

            <Stack direction="row" alignItems="center" spacing={1} sx={{ minWidth: 250, justifyContent: "flex-end", display: { xs: "none", md: "flex" } }}>
              <Box sx={{ minWidth: 170 }}>
                <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>
                  Visualização
                </InputLabel>
                <MDSelect
                  name="view"
                  getOptionValue={(option) => option.id}
                  getOptionLabel={(option) => option.name}
                  placeholder="Selecione a data"
                  value={tipoFiltroAgendaEnum.find((item) => item.code === filters.view) || null}
                  options={tipoFiltroAgendaSelect}
                  onChange={(option) => {
                    const newView = option.code;

                    localStorage.setItem("home_agenda_view", newView);

                    setFilters(prev => ({
                      ...prev,
                      view: newView
                    }));

                    updateDateRange(newView);
                  }}
                />
              </Box>

              {canCreateEvento && (
                <MDButton
                  startIcon={<AddIcon />}
                  variant="contained"
                  color="info"
                  onClick={() => setOpenCreate(true)}
                  style={{ marginTop: 12 }}
                >
                  Novo Evento
                </MDButton>
              )}
            </Stack>
          </Stack>
        </Stack>

        {/* Blocos de Resumo da Fila de Trabalho (Apenas para perfis Operação e Backoffice) */}
        {showResumoBlocks && (
          <Grid container spacing={2} alignItems="stretch" sx={{ mb: 2 }}>
            {/* 1: Na Fila */}
            <Grid item xs={12} md={4} display="flex">
              <Card
                onClick={() => handleOpenResumoDetail("Na Fila", resumoFilaData?.naFila, "info")}
                sx={{
                  py: 1.5,
                  px: 2,
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  cursor: "pointer",
                  borderRadius: "10px",
                  background: darkMode ? `linear-gradient(145deg, ${ESCURO.cartao} 0%, ${ESCURO.painel} 100%)` : "linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%)",
                  border: "1px solid",
                  borderColor: darkMode ? ESCURO.divisoria : "#e0e0e0",
                  transition: "transform 0.2s, box-shadow 0.2s",
                  "&:hover": {
                    transform: "translateY(-2px)",
                    boxShadow: darkMode ? "0 6px 18px rgba(0,0,0,0.4)" : "0 6px 18px rgba(0,0,0,0.1)",
                  },
                }}
              >
                <MDBox>
                  <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={0.5}>
                    <MDBox display="flex" alignItems="center" gap={0.8}>
                      <Icon color="info" sx={{ fontSize: 20 }}>queue</Icon>
                      <MDTypography variant="button" fontWeight="bold" color="info" sx={{ fontSize: "0.85rem" }}>
                        1: Na Fila
                      </MDTypography>
                    </MDBox>
                    <MDTypography variant="caption" color="text" sx={{ opacity: 0.8, fontSize: "0.72rem" }}>
                      Ver detalhes &rarr;
                    </MDTypography>
                  </MDBox>

                  <MDTypography variant="h4" fontWeight="bold" color="info" mb={0.25}>
                    {resumoFilaData?.naFila?.total || 0}{" "}
                    <MDTypography variant="caption" color="text" fontWeight="regular" sx={{ fontSize: "0.75rem" }}>casos</MDTypography>
                  </MDTypography>
                </MDBox>

                {renderStatusChips(resumoFilaData?.naFila?.porStatus, "info")}
              </Card>
            </Grid>

            {/* 2: Trabalhados */}
            <Grid item xs={12} md={4} display="flex">
              <Card
                onClick={() => handleOpenResumoDetail("Trabalhados", resumoFilaData?.trabalhados, "success")}
                sx={{
                  py: 1.5,
                  px: 2,
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  cursor: "pointer",
                  borderRadius: "10px",
                  background: darkMode ? `linear-gradient(145deg, ${ESCURO.cartao} 0%, ${ESCURO.painel} 100%)` : "linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%)",
                  border: "1px solid",
                  borderColor: darkMode ? ESCURO.divisoria : "#e0e0e0",
                  transition: "transform 0.2s, box-shadow 0.2s",
                  "&:hover": {
                    transform: "translateY(-2px)",
                    boxShadow: darkMode ? "0 6px 18px rgba(0,0,0,0.4)" : "0 6px 18px rgba(0,0,0,0.1)",
                  },
                }}
              >
                <MDBox>
                  <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={0.5}>
                    <MDBox display="flex" alignItems="center" gap={0.8}>
                      <Icon color="success" sx={{ fontSize: 20 }}>task_alt</Icon>
                      <MDTypography variant="button" fontWeight="bold" color="success" sx={{ fontSize: "0.85rem" }}>
                        2: Trabalhados
                      </MDTypography>
                    </MDBox>
                    <MDTypography variant="caption" color="text" sx={{ opacity: 0.8, fontSize: "0.72rem" }}>
                      Ver detalhes &rarr;
                    </MDTypography>
                  </MDBox>

                  <MDTypography variant="h4" fontWeight="bold" color="success" mb={0.25}>
                    {resumoFilaData?.trabalhados?.total || 0}{" "}
                    <MDTypography variant="caption" color="text" fontWeight="regular" sx={{ fontSize: "0.75rem" }}>casos</MDTypography>
                  </MDTypography>
                </MDBox>

                {renderStatusChips(resumoFilaData?.trabalhados?.porStatus, "success")}
              </Card>
            </Grid>

            {/* 3: A Trabalhar */}
            <Grid item xs={12} md={4} display="flex">
              <Card
                onClick={() => handleOpenResumoDetail("A Trabalhar", resumoFilaData?.aTrabalhar, "warning")}
                sx={{
                  py: 1.5,
                  px: 2,
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  cursor: "pointer",
                  borderRadius: "10px",
                  background: darkMode ? `linear-gradient(145deg, ${ESCURO.cartao} 0%, ${ESCURO.painel} 100%)` : "linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%)",
                  border: "1px solid",
                  borderColor: darkMode ? ESCURO.divisoria : "#e0e0e0",
                  transition: "transform 0.2s, box-shadow 0.2s",
                  "&:hover": {
                    transform: "translateY(-2px)",
                    boxShadow: darkMode ? "0 6px 18px rgba(0,0,0,0.4)" : "0 6px 18px rgba(0,0,0,0.1)",
                  },
                }}
              >
                <MDBox>
                  <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={0.5}>
                    <MDBox display="flex" alignItems="center" gap={0.8}>
                      <Icon color="warning" sx={{ fontSize: 20 }}>pending_actions</Icon>
                      <MDTypography variant="button" fontWeight="bold" color="warning" sx={{ fontSize: "0.85rem" }}>
                        3: A Trabalhar
                      </MDTypography>
                    </MDBox>
                    <MDTypography variant="caption" color="text" sx={{ opacity: 0.8, fontSize: "0.72rem" }}>
                      Ver detalhes &rarr;
                    </MDTypography>
                  </MDBox>

                  <MDTypography variant="h4" fontWeight="bold" color="warning" mb={0.25}>
                    {resumoFilaData?.aTrabalhar?.total || 0}{" "}
                    <MDTypography variant="caption" color="text" fontWeight="regular" sx={{ fontSize: "0.75rem" }}>casos</MDTypography>
                  </MDTypography>
                </MDBox>

                {renderStatusChips(resumoFilaData?.aTrabalhar?.porStatus, "warning")}
              </Card>
            </Grid>
          </Grid>
        )}

        <Card
          variant="outlined"
          sx={{
            px: 2,
            py: 1.5,
            mb: 2,
            background: darkMode ? ESCURO.cartao : "#fafafa",
            borderColor: darkMode ? ESCURO.divisoria : "#ddd",
          }}
        >
          <Grid container spacing={1} alignItems="center">

            <Grid item xs={12} sm={2} sx={{ minWidth: 250, justifyContent: "flex-end", display: { xs: "flex", md: "none" }, flexDirection: "column" }}>
              <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>
                Visualização
              </InputLabel>
              <MDSelect
                name="view"
                getOptionValue={(option) => option.id}
                getOptionLabel={(option) => option.name}
                placeholder="Selecione a data"
                value={tipoFiltroAgendaEnum.find((item) => item.code === filters.view) || null}
                options={tipoFiltroAgendaSelect}
                onChange={(option) => {
                  const newView = option.code;

                  localStorage.setItem("home_agenda_view", newView);

                  setFilters(prev => ({
                    ...prev,
                    view: newView
                  }));

                  updateDateRange(newView);
                }}
              />

              {canCreateEvento && (
                <MDButton
                  startIcon={<AddIcon />}
                  variant="contained"
                  color="info"
                  onClick={() => setOpenCreate(true)}
                  style={{ marginTop: 12 }}
                >
                  Novo Evento
                </MDButton>
              )}
            </Grid>

            <Grid item xs={12} sm={2}>
              <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Carteira</InputLabel>
              <MDSelect
                isLoading={loadingCarteira}
                isDisabled={loadingCarteira || carteiraList.length <= 1}
                getOptionValue={option => option.id}
                getOptionLabel={option => option.nome}
                name='carteiras'
                placeholder={loadingCarteira ? "" : "Selecione"}
                value={withAllOption(carteiraList).find((c) => c.id === (filters.carteiraId || null)) || withAllOption(carteiraList)[0]}
                options={withAllOption(carteiraList)}
                onChange={selectedOptions => {
                  setFilters(prev => ({ 
                    ...prev, 
                    carteiraId: selectedOptions?.id || null,
                    tipoPrazo: null,
                    status: null,
                    statusFichaId: null,
                  }))
                }}
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Cliente</InputLabel>
              <MDSelect
                isLoading={loadingPeople}
                isDisabled={loadingPeople}
                getOptionValue={option => option.id}
                getOptionLabel={option => option.nomeComum || option.name}
                name='clientes'
                placeholder={loadingPeople ? "" : "Selecione"}
                value={withAllOption(clienteList).find((c) => c.id === (filters.clienteId || null)) || withAllOption(clienteList)[0]}
                options={withAllOption(clienteList)}
                onChange={selectedOptions => {
                  setFilters(prev => ({ ...prev, clienteId: selectedOptions?.id || null }))
                }}
              />
            </Grid>

            {filters.view === "day" && (
              <Grid item xs={12} sm={2}>
                <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Data Início</InputLabel>
                <MDTextFieldCalendar
                  name="dataInicio"
                  type="date"
                  fullWidth
                  size="small"
                  value={filters.dataInicio}
                  disabled={false}
                  inputProps={{
                    min: minDate,
                    max: maxDate,
                  }}
                  onChange={(e) => {
                    const val = e.target.value;
                    setFilters(prev => ({ ...prev, dataInicio: val, dataFim: val }));
                    setCurrentDate(moment(val));
                  }}
                  InputLabelProps={{ shrink: true }}
                  darkMode={darkMode}
                />
              </Grid>
            )}

            {(hasCobranca || isAdmin) && (
              <Grid item xs={12} sm={2}>
                <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Status (Ficha)</InputLabel>
                <MDSelect
                  getOptionValue={option => option.id}
                  getOptionLabel={option => option.name || option.ccNome}
                  name='statusFicha'
                  placeholder="Selecione"
                  value={withAllOption(statusFichaList).find((c) => c.id === (filters.statusFichaId || null)) || withAllOption(statusFichaList)[0]}
                  options={withAllOption(statusFichaList)}
                  onChange={selectedOptions => {
                    setFilters(prev => ({ ...prev, statusFichaId: selectedOptions?.id || null }))
                  }}
                />
              </Grid>
            )}

            <Grid item xs={12} sm={2}>
              <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>
                Atribuído a
              </InputLabel>
              <MDSelect
                placeholder="Selecione"
                name="atribuido"
                isLoading={loadingUsuarios}
                isDisabled={loadingUsuarios || (hasCobranca && !hasProcessos && !isAdmin && !isCoordinator)}
                getOptionValue={(option) => option.id}
                getOptionLabel={(option) => option.nome || option.name}
                options={withAllOption(usuarios)}
                value={
                  withAllOption(usuarios).find((u) => {
                    if (filters.atribuidoA === null || filters.atribuidoA === "") {
                      return u.id === null;
                    }
                    return u.id != null && String(u.id) === String(filters.atribuidoA);
                  }) || null
                }
                onChange={(option) => {
                  setFilters((prev) => ({
                    ...prev,
                    atribuidoA: option?.id ?? null
                  }));
                }}
              />
            </Grid>

            {(hasProcessos || isAdmin) && (
              <>
                <Grid item xs={12} sm={2}>
                  <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>
                    Tipo do Evento
                  </InputLabel>
                  <MDSelect
                    placeholder="Selecione o tipo"
                    name="tipoPrazo"
                    getOptionValue={(option) => option.id}
                    getOptionLabel={(option) => option.name}
                    options={withAllOption(tipoEventoEnum)}
                    value={withAllOption(tipoEventoEnum).find((item) => item.code === filters.tipoPrazo) || null}
                    onChange={(option) => {
                      setFilters((prev) => ({ 
                        ...prev, 
                        tipoPrazo: option.code || null,
                        
                        ...(option.code !== "deadline" && {
                          dataInicioPublicacao: null,
                          dataFimPublicacao: null,
                        }),
                      }));
                    }}
                  />
                </Grid>

              {filters.tipoPrazo !== "endSuspension" && filters.tipoPrazo !== "endSuspensionProcess" &&
                <Grid item xs={12} sm={2} >
                  <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>
                    Status do Evento
                  </InputLabel>
                  <MDSelect
                    name="statusPrazo"
                    placeholder="Selecione o status"
                    getOptionValue={(option) => option.id}
                    getOptionLabel={(option) => option.name}
                    options={withAllOption(statusPrazoEnum)}
                    value={withAllOption(statusPrazoEnum).find((item) => item.code === filters.status) || null}
                    onChange={(option) => {
                      setFilters((prev) => ({
                        ...prev,
                        status: option.code || null
                      }));
                    }}
                  />
                </Grid>
              }

              <Grid item xs={12} sm={2}>
                <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Nº Processo</InputLabel>
                <MDInput
                  fullWidth
                  size="small"
                  placeholder="Buscar processo"
                  value={search.processo}
                  onChange={(e) =>
                    setSearch(prev => ({ ...prev, processo: e.target.value }))
                  }
                />
              </Grid>

              {filters.tipoPrazo && filters.tipoPrazo !== "endSuspension" && filters.tipoPrazo !== "endSuspensionProcess" && (
                <>
                  <Grid item xs={12} sm={2}>
                    <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>
                      Data Início Publicação
                    </InputLabel>
                    <MDTextFieldCalendar
                      name="dataInicioPublicacao"
                      type="date"
                      fullWidth
                      value={filters.dataInicioPublicacao || ""}
                      onChange={(e) => {
                        setFilters(prev => ({
                          ...prev,
                          dataInicioPublicacao: e.target.value
                        }));
                      }}
                      InputLabelProps={{ shrink: true }}
                      darkMode={darkMode}
                    />
                  </Grid>

                  <Grid item xs={12} sm={2}>
                    <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>
                      Data Fim Publicação
                    </InputLabel>
                    <MDTextFieldCalendar
                      name="dataFimPublicacao"
                      type="date"
                      fullWidth
                      value={filters.dataFimPublicacao || ""}
                      onChange={(e) => {
                        setFilters(prev => ({
                          ...prev,
                          dataFimPublicacao: e.target.value
                        }));
                      }}
                      InputLabelProps={{ shrink: true }}
                      darkMode={darkMode}
                    />
                  </Grid>
                </>
              )}
            </>
            )}

            <Grid item xs={12} sm={2} >
              <MDButton size="medium"
                variant="contained"
                color="info"
                fullWidth
                style={{ marginTop: 12 }}
                onClick={() => {
                  setFilters(prev => ({
                    ...prev,
                    tipoPrazo: "",
                    atribuidoA: "",
                    status: "",
                  }));

                  handleClearFilters();
                }}
              >
                Limpar Filtros
              </MDButton>
            </Grid>

          </Grid>

        </Card>

        {renderCalendar()}

        <ModalDetails
          open={openModal}
          onClose={handleCloseModal}
          selectedEvent={selectedEvent}
          setSelectedEvent={setSelectedEvent}
          onOpenProcess={handleOpenProcess}
          onOpenHistory={handleOpenHistory}
          fetchAgenda={fetchAgenda}
        />

        <ModalCriarAgenda
          open={openCreate}
          onClose={() => setOpenCreate(false)}
          usuarios={usuarios}
          fetchAgenda={fetchAgenda}
        />

        <ModalResumoFila
          open={openResumoModal}
          onClose={() => setOpenResumoModal(false)}
          title={modalResumoTitle}
          blockData={modalResumoBlockData}
          color={modalResumoColor}
          onOpenFicha={(devedorEncryptedId) => {
            setOpenResumoModal(false);
            setFichaId(devedorEncryptedId);
            setOpenFicha(true);
          }}
        />

      </Card>
    </>

  );
}
